import { FetcherPaginated, FetchParams } from "../../Shared/types";
import { RequestCriteriaType } from "@infrastructure/Services/PostService.types";
import { useEffect, useRef, useState } from "react";
import useInfiniteScroll from "react-infinite-scroll-hook";
import { ROOT_MARGIN } from "../Post/PostsWrapper";
import { useCursoredInfiniteScroll } from "@infrastructure/Hooks/InfiniteScroll/useCursoredInfiniteScroll";
import { fetcherMediaList } from "../../DataFetchers/MediaFetcher";
import { MediaListType } from "@infrastructure/Services/MediaService";

const getMediaFetcher: FetcherPaginated<MediaListType> = ({
    sortCriteria,
}: FetchParams) => fetcherMediaList(sortCriteria);

const noopFetcher: FetcherPaginated<MediaListType> = () => {
    return Promise.resolve([]);
};

export function useImagesWithInfiniteScroll({
    sortCriteria,
}: {
    sortCriteria?: RequestCriteriaType;
}) {
    const [listOptions, setListOptions] = useState({
        fetcher: noopFetcher,
        fetchParams: {
            sortCriteria,
        },
        maxItemCount: 5000,
    });
    const {
        loading,
        items: mediaList,
        hasNextPage,
        error,
        loadMore,
        isInitDone,
        resetParams,
    } = useCursoredInfiniteScroll(
        listOptions.fetcher,
        listOptions.fetchParams,
        {},
        listOptions.maxItemCount,
    );

    const [infiniteRef, { rootRef }] = useInfiniteScroll({
        loading,
        hasNextPage,
        onLoadMore: loadMore,
        disabled: !!error,
        rootMargin: ROOT_MARGIN.SEMI_LAZY,
    });

    useEffect(() => {
        setListOptions((prevState) => ({
            ...prevState,
            fetcher: getMediaFetcher,
            fetchParams: {
                sortCriteria,
            },
        }));

        return () => {
            setListOptions((prevState) => ({
                ...prevState,
                fetcher: noopFetcher,
                fetchParams: {
                    sortCriteria,
                },
            }));
            batchesLoadedRef.current = 0;
        };
    }, [sortCriteria]);

    useEffect(() => {
        resetParams(listOptions.fetchParams);
    }, [listOptions.fetchParams]);

    const batchesLoadedRef = useRef(0);
    useEffect(() => {
        if (!isInitDone) {
            return;
        }
        batchesLoadedRef.current = batchesLoadedRef.current + 1;
    }, [isInitDone]);

    return {
        infiniteRef,
        mediaList,
        rootRef,
    };
}
